import { render, staticRenderFns } from "./ValidationRulesManagement.vue?vue&type=template&id=323d6cf4&scoped=true"
import script from "./ValidationRulesManagement.vue?vue&type=script&lang=js"
export * from "./ValidationRulesManagement.vue?vue&type=script&lang=js"
import style0 from "./ValidationRulesManagement.vue?vue&type=style&index=0&id=323d6cf4&prod&lang=css"
import style1 from "./ValidationRulesManagement.vue?vue&type=style&index=1&id=323d6cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323d6cf4",
  null
  
)

export default component.exports